import 'css-chunk:src/About/About.module.scss';export default {
  "card_title_img": "card_title_img__ddwpP",
  "test": "test__ICevD",
  "bg": "bg__rW1jS",
  "row": "row__zlGxN",
  "item": "item__5646-"
};